export default function Logo() {
  return <h1>🏝️ Far away 🇵🇭</h1>;
}
